module.exports = "images/txt-big.png";